import { dbAdd, dbDelete, dbGetAll, dbGetById, dbPut } from '../indexedDb.ts';

export interface LocalObjective {
  id: number;
  title: string;
  description?: string;
  period_type: 'annual' | 'quarterly';
  period_start?: string;
  period_end?: string;
  status: 'active' | 'archived';
  created_at: string;
  updated_at?: string;
  server_id?: number;
  last_synced_at?: string;
  needs_sync?: boolean;
}

export function listObjectives() {
  return dbGetAll<LocalObjective>('okr_objectives');
}

export function getObjectiveById(id: number) {
  return dbGetById<LocalObjective>('okr_objectives', id);
}

export async function getObjectiveByServerId(serverId: number) {
  const all = await listObjectives();
  return all.find((item) => item.server_id === serverId);
}

export async function createObjective(
  data: Omit<LocalObjective, 'id' | 'created_at' | 'updated_at' | 'server_id' | 'last_synced_at' | 'needs_sync'>
) {
  const now = new Date().toISOString();
  return dbAdd('okr_objectives', { ...data, created_at: now, needs_sync: true } as any);
}

export async function updateObjective(id: number, data: Partial<LocalObjective>) {
  const current = await dbGetById<LocalObjective>('okr_objectives', id);
  if (!current) throw new Error('Objective not found');
  const updated = {
    ...current,
    ...data,
    id,
    updated_at: data.updated_at ?? new Date().toISOString(),
    needs_sync: data.needs_sync ?? true,
  };
  await dbPut('okr_objectives', updated);
  return updated;
}

export function removeObjective(id: number) {
  return dbDelete('okr_objectives', id);
}

export async function getObjectivesNeedingSync(): Promise<LocalObjective[]> {
  const all = await listObjectives();
  return all.filter((o) => o.needs_sync === true);
}

export async function markObjectiveSynced(id: number, serverId: number) {
  const current = await dbGetById<LocalObjective>('okr_objectives', id);
  if (!current) throw new Error('Objective not found');
  current.server_id = serverId;
  current.last_synced_at = new Date().toISOString();
  current.needs_sync = false;
  await dbPut('okr_objectives', current);
  return current;
}
